export enum TRUCK_DRIVER_CHANGE_KEYS {
  DRIVER_NAME = 'Driver',
  SECOND_DRIVER_NAME = 'SecondDriver',
  DRIVER_PHONE_NUMBER = 'DriverPhone',
  DRIVER_PHONE_COUNTRY_ID = 'DriverPhoneCountryId',
  SECOND_DRIVER_PHONE_NUMBER = 'SecondDriverPhoneNumber',
  SECOND_DRIVER_PHONE_COUNTRY_ID = 'SecondDriverPhoneCountryId',
  TRUCK_NUMBER = 'TruckNumber',
  TRAILER_NUMBER = 'TrailerNumber'
}

export type TeamLoadChangeKey = 'Driver' | 'DriverPhone';
export type TeamLoadChangeKey2 = 'SecondDriver' | 'SecondDriverPhoneNumber';
